import React, { ImgHTMLAttributes } from 'react'
import crystal from './HoneyStacked/crystal.png'

export const DailyLogo: React.FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => (
  <img
    src={crystal}
    width={150}
    height={150}
    alt="Daily Logo"
    style={{ display: 'block' }}
    {...props}
  />
)
